// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './style/element-variables.scss'
import App from './App'
import router from './router'
import store from './store'
import api from './api'
import * as storeTypes from './store/mutation-types'
import globalMixin from './mixins/global'
import directives from '@/directives' // eslint-disable-line

Vue.use(Vuex)
Vue.use(ElementUI)

Vue.prototype.$storeTypes = storeTypes
Vue.prototype.$api = api

Vue.config.productionTip = false

Vue.mixin(globalMixin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  container: ''
})



// WEBPACK FOOTER //
// ./src/main.js